import { ApiController } from 'config';
import { IDiscountsContent } from 'interfaces';
import { AppDispatch } from 'redux/store';
import { showErrorAlert } from 'redux/utils';
import { get } from 'services';
import { t } from 'i18next';

export const getArchivedDiscountsData = async (
  dispatch: AppDispatch,
): Promise<IDiscountsContent[]> => {
  try {
    const response = await get<IDiscountsContent[]>({
      url: `${ApiController.archivedDiscounts}?size=1000&`,
    });
    return response ?? [];
  } catch (error) {
    showErrorAlert(
      dispatch,
      error,
      t('alert.ERRORS.favorite_fetch_error.title'),
    );
    return [];
  }
};
